import React, { useState } from 'react'
import { WithdrawInput } from 'src/components/Global/Input/Input'
import { removeComma, removeLetters } from 'src/utils/addNairaSign'
import { AmountWrapper } from './style'

interface Props {
  amount: string
  fullWithdrawal: boolean
  balance: string | number
  toggleFullWithdrawal: (val?: boolean) => void
  onEnterAmount: (amount: string) => void
}

const Amount = ({
  amount,
  balance,
  fullWithdrawal,
  toggleFullWithdrawal,
  onEnterAmount,
}: Props) => {
  const [theAmount, setTheAmount] = useState('')

  const handleChange = (e: any) => {
    const { value } = e.target
    // const _amount = removeComma(removeLetters(value ?? 0))
    const _amount = removeComma(removeLetters(value))
    onEnterAmount(_amount)
    setTheAmount(_amount)

    toggleFullWithdrawal(false)
  }

  const handleFullWithdrawal = () => {
    toggleFullWithdrawal()
    const bal = removeComma(removeLetters(`${balance}`))
    const amnt = removeComma(removeLetters(`${theAmount}`))
    if (fullWithdrawal === true) {
      onEnterAmount(`${bal}`)
    } else {
      onEnterAmount(`${amnt}`)
    }
  }

  return (
    <AmountWrapper>
      <div className="input_wrapper">
        <p>Enter Amount to withdraw</p>
        <WithdrawInput
          type={'text'}
          placeholder="0"
          value={amount}
          onChange={handleChange}
        />
        <div className="check_full_withdrawal" onClick={handleFullWithdrawal}>
          <p className="withdraw_text">Make full withdrawal</p>
        </div>
      </div>
    </AmountWrapper>
  )
}

export default Amount
